import React, { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import {
  useLazyAdminViewQuery,
  useAdminAddMutation,
  useAdminEditMutation,
  useLazyAdminRoleQuery,
} from "../../redux/api/api";
import { saveLoader } from "../../redux/slice/loaderNoti";
import TopHeader from "../Dashoboard/TopHeader";

const AdminPage = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const types = location?.state?.type;

  const [roles, setRole] = useState("");
  const [name, setName] = useState("");
  const [conPassword, setConPassword] = useState("");
  const [password, setPassword] = useState("");
  const [username, setUserName] = useState("");
  const [email, setEmail] = useState("");
  const [rolesErr, setRoleErr] = useState(false);
  const [nameErr, setNameErr] = useState(false);
  const [conPasswordErr, setConPasswordErr] = useState(false);
  const [passwordErr, setPasswordErr] = useState(false);
  const [usernameErr, setUserNameErr] = useState(false);
  const [emailErr, setEmailErr] = useState(false);
  const [btn, setBtn] = useState(false);
  const [roleList, setRoleList] = useState([]);

  // RTK QUERY
  const [adminAddApi] = useAdminAddMutation();
  const [admiEditApi] = useAdminEditMutation();
  const [adminViewApi] = useLazyAdminViewQuery();
  const [adminRoleApi] = useLazyAdminRoleQuery();

  const submitHandler = () => {
    if (
      name?.length == 0 ||
      username?.length == 0 ||
      email?.length == 0 ||
      (types !== "edit" && password?.length == 0) ||
      (types !== "edit" && conPassword?.length == 0) ||
      roles?.length == 0
    ) {
      setRoleErr(true);
      setNameErr(true);
      setUserNameErr(true);
      setEmailErr(true);
      if (types !== "edit") {
        setConPasswordErr(true);
        setPasswordErr(true);
      }
    } else {
      let formdata = new FormData();
      formdata.append("role_id", roles);
      formdata.append("name", name);
      formdata.append("username", username);
      formdata.append("email", email);

      if (password) {
        formdata.append("password", password);
        formdata.append("confirm_password", conPassword);
      }

      let count = 1;

      if (password !== conPassword) {
        count = count + 1;
      }

      if (count == 1) {
        if (types == "edit") {
          dispatch(saveLoader(true));
          setBtn(true);
          formdata.append("_method", "PUT");
          admiEditApi({ id: location?.state?.data?.id, payload: formdata })
            .unwrap()
            .then((res) => {
              dispatch(saveLoader(false));
              setBtn(false);
              if (res?.status == "success") {
                Swal.fire({
                  text: res?.message,
                  icon: "success",
                });
                navigate("/admins");
              }
            })
            .catch((err) => {
              dispatch(saveLoader(false));
              setBtn(false);
              console.log("err");
            });
        } else {
          dispatch(saveLoader(true));
          setBtn(true);
          adminAddApi(formdata)
            .unwrap()
            .then((res) => {
              dispatch(saveLoader(false));
              setBtn(false);
              if (res?.status === "success") {
                Swal.fire({
                  text: res?.message,
                  icon: "success",
                });
                navigate("/admins");
              }
            })
            .catch((err) => {
              dispatch(saveLoader(false));
              setBtn(false);
              console.error("Error", err);
            });
        }
      }
    }
  };

  const getView = () => {
    dispatch(saveLoader(true));
    adminViewApi(location?.state?.data?.id)
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        if (res?.status == "success" || res?.data?.status == "success") {
          setName(res?.admin?.name);
          setUserName(res?.admin?.username);
          setRole(res?.admin?.role_id);
          setEmail(res?.admin?.email);
        }
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        console.log("err");
      });
  };

  const getRoles = () => {
    dispatch(saveLoader(true));
    adminRoleApi()
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        if (res?.status == "success" || res?.data?.status == "success") {
          setRoleList(res?.roles);
        }
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        console.log("err");
      });
  };

  useEffect(() => {
    if (location?.state?.data?.id) {
      getView();
    }
    getRoles();
  }, []);

  return (
    <div className="dashRightView home_section">
      <TopHeader
        type={
          types == "view"
            ? "view-admin"
            : types == "edit"
            ? "edit-admin"
            : "add-admin"
        }
      />
      <div className="mt-4 block block-rounded ">
        <div className="block-content">
          <Row>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Name
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setName(e.target.value)}
                  value={name}
                  disabled={types == "view" ? true : false}
                />
              </div>
              {name?.length == 0 && nameErr && (
                <p className="err">Enter Name</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Username{" "}
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setUserName(e.target.value)}
                  value={username}
                  disabled={types == "view" ? true : false}
                />
              </div>
              {username?.length == 0 && usernameErr && (
                <p className="err">Enter Username</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Email
                </label>
                <input
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setEmail(e.target.value)}
                  value={email}
                  disabled={types == "view" ? true : false}
                />
              </div>
              {email?.length == 0 && emailErr && (
                <p className="err">Enter Email</p>
              )}
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Role
                </label>
                <select
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) => setRole(e.target.value)}
                  value={roles}
                  disabled={types == "view" ? true : false}
                >
                  <option value={""} disabled>
                    Select Role
                  </option>
                  {roleList?.map((item, ind) => {
                    return (
                      <option value={item?.id} key={ind}>
                        {item?.role}
                      </option>
                    );
                  })}
                </select>
              </div>
              {roles?.length == 0 && rolesErr && (
                <p className="err">Select Role</p>
              )}
            </div>
            {types == "view" ? null : (
              <>
                <div className="col-md-6 mb-3">
                  <div className="form-group">
                    <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                      Password
                    </label>
                    <input
                      className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                      onChange={(e) => setPassword(e.target.value)}
                      value={password}
                      disabled={types == "view" ? true : false}
                    />
                  </div>
                  {password?.length == 0 && passwordErr && (
                    <p className="err">Enter Password</p>
                  )}
                </div>
                <div className="col-md-6 mb-3">
                  <div className="form-group">
                    <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                      Confirm Password
                    </label>
                    <input
                      className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                      onChange={(e) => setConPassword(e.target.value)}
                      value={conPassword}
                      disabled={types == "view" ? true : false}
                    />
                  </div>
                  {conPassword?.length == 0 && conPasswordErr && (
                    <p className="err">Enter Confirm Password </p>
                  )}

                  {conPassword?.length > 1 && password !== conPassword && (
                    <p className="err">Confirm Password does not match </p>
                  )}
                </div>
              </>
            )}
          </Row>
          <Row>
            {types == "view" ? null : (
              <div className="col-md-12 text-center mt-4 mb-4">
                <button
                  className={`submit-btn f2  ${btn ? "opacity-50" : ""}`}
                  onClick={() => submitHandler()}
                  disabled={btn}
                >
                  Save
                </button>
              </div>
            )}
          </Row>
        </div>
      </div>
    </div>
  );
};

export default AdminPage;
